import { render, staticRenderFns } from "./AccreditationUpdateBox.vue?vue&type=template&id=6afd8336&scoped=true"
import script from "./AccreditationUpdateBox.vue?vue&type=script&lang=js"
export * from "./AccreditationUpdateBox.vue?vue&type=script&lang=js"
import style0 from "./AccreditationUpdateBox.vue?vue&type=style&index=0&id=6afd8336&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afd8336",
  null
  
)

export default component.exports